// packages/ui-kit/src/people/AvailabilityChip.tsx
// C3F v18 — reference: design/system/components/people/AvailabilityChip.{jsx,prompt.md}
// Squared 8px: it belongs to the grid, not to the pills. Mono, nowrap — days
// and slots are reading units. Soft tints pair ONLY with their own ink; the
// "not indicated" state sits on bg-subtle (opaque), never on a veil.
// Careful with copy: the shifts grid does NOT read availabilities — never say
// "who is free".
import type { AvailabilityRule, AvailabilityRuleType } from "@praesto/shared-types";

const labels: Record<AvailabilityRuleType, string> = {
  unavailable: "Non disponibile",
  preferred_off: "Preferisce no",
  preferred_on: "Preferito",
};

// Each soft tint with its paired ink, nothing else (build.md).
const stateCls: Record<AvailabilityRuleType, string> = {
  unavailable: "bg-danger-soft text-danger",
  preferred_off: "bg-warning-soft text-warning",
  preferred_on: "bg-accent-soft text-accent-text",
};

const dayNames = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export function AvailabilityChip({
  rule,
  onRemove,
}: {
  /** Omit for the "not indicated" cell of an availability grid. */
  rule?: AvailabilityRule;
  onRemove?: () => void;
}) {
  const base =
    "inline-flex min-h-[26px] items-center gap-[7px] whitespace-nowrap rounded-sm px-2.5 font-mono text-mono";

  if (!rule) {
    return <span className={`${base} bg-subtle text-fg-muted`}>Non indicata</span>;
  }

  const day = rule.dayOfWeek !== undefined ? dayNames[rule.dayOfWeek] : "Ogni giorno";
  return (
    <span className={`${base} ${stateCls[rule.type]}`}>
      <strong className="font-semibold">{day}</strong>
      <span>
        {labels[rule.type]}
        {rule.slot ? ` · ${rule.slot}` : ""}
      </span>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label="Rimuovi regola"
          className="-mr-1 inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-full leading-none transition-colors duration-fast hover:bg-hover focus-visible:outline-none focus-visible:shadow-focus sm:h-5 sm:w-5"
        >
          ×
        </button>
      )}
    </span>
  );
}
